<template>
  <div>Эм, бэлдмэлийн тайлан</div>
</template>
<script>
export default {};
</script>
